import { ContentResponse } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { config } from "JS/Config";

export class VideoService extends BaseService {
    getVideos = () =>
        this.ngCall<ContentResponse>(
            "get",
            appConstants.ngEndpoints.videoListing(config.user.memberId),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );
}
